import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { first, Subscription } from 'rxjs';
import { UserListItem } from 'src/app/common/models/users-data/user-list-item.model';
import { DialogsManagerService } from 'src/app/services/dialogs-manager.service';
import { UserListService } from 'src/app/services/user-list.service';
import { environment } from 'src/environments/environment';
import { SearchOptionsEnum } from './enums/search-options-enum';
import pkg from '../../../../../package.json';
import buildDate from '../../../../../buildDate.json';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    standalone: false
})
export class HomeComponent implements OnInit
{
  subscription: Subscription = new Subscription()

  public version: string = pkg.version;
  public environmentName=environment.name
  public buildDateTime=buildDate.timestamp

  search: FormControl = new FormControl({ value: '', disabled: true })


  searchListSource: UserListItem[] = []
  searchClinicListSource: string[] = []

  SearchOptionsEnum = SearchOptionsEnum

  currentSearchOption = SearchOptionsEnum.userName
  searchWasEmpty = true
 
  constructor(private dialogsManagerService: DialogsManagerService, private userListService: UserListService) { }


  ngOnInit(): void
  {
    this.userListService.loadedUserListSubject.pipe(first(l_loaded => l_loaded == true)).subscribe(() =>
    {
      this.searchListSource = this.userListService.data

      let l_clinics: string[] = this.userListService.data.map(function (item)
      {
        return item.clinicId ? item.clinicId : ''
      })

      this.searchClinicListSource = [...new Set(l_clinics)]

      this.search.enable()
    })

    let l_sub = this.search.valueChanges.subscribe(l_change =>
    {
      if (!(this.searchWasEmpty && l_change == ''))
      {
        switch (this.currentSearchOption)
        {
          case SearchOptionsEnum.userName: {

            this.filterByUserName(l_change)
            break;
          }

          case SearchOptionsEnum.email: {

            this.filterByEmail(l_change)
            break;
          }

          case SearchOptionsEnum.clinicId: {

            this.filterByClinic(l_change)
          }
            break;

          default:
            break;
        }
        if (l_change == '')
        {
          this.searchWasEmpty = true
        } else
        {
          this.searchWasEmpty = false
        }


      }
    })

    this.subscription.add(l_sub)


    
  }



  filterByUserName(userName: string)
  {
    this.userListService.filterTableByUserName.next(userName)
  }

  filterByEmail(userId: string)
  {
    this.userListService.filterTableByEmail.next(userId)
  }

  filterByClinic(clinicId: string)
  {
    this.userListService.filterTableByClinicId.next(clinicId)
  }
  showCreateNewUserDialog()
  {
    this.dialogsManagerService.showCreateUserDialogComponent()
  }

  setSearchOption(option: SearchOptionsEnum)
  {
    this.currentSearchOption = option
    this.filterByUserName('')
    this.filterByEmail('')
    this.filterByClinic('')
    this.search.setValue('')

  }
}
